import React, { useState } from "react";
import { CMPDataTable } from "../../Components/Leads/CMP/CMPDataTable";
import { CMPFirst } from "../../Components/Leads/CMP/CMPFirst";

export const CMPComponent = () => {
  const [filters, setFilters] = useState({});

  return (
    <div>
      <CMPFirst onFilterChange={setFilters} />
      <CMPDataTable filters={filters} />
    </div>
  );
};
